import { defineStore } from 'pinia';
import actions from './actions';
import getters from './getters';

const useProfileStore = defineStore('user', {
  state: () => ({
    profile: null,
    isAuth: false,
    promotionParticipation: null,
    token: null,
    distinctId: null,
    paymentMethods: [],
    selectedCardId: 'stripe',
    paymentSettings: null,
  }),
  actions,
  getters,
});

export default useProfileStore;
